module.exports = __webpack_public_path__ + "img/device_r.5ee80b95.svg";